import {
  Button,
  Layout,
  theme,
  Form,
  Input,
  Spin,
  notification,
  Select,
} from "antd";

import React, { useEffect, useCallback, useState } from "react";
import "../CreateRole/CreateRole.css";

import { Row, Col } from "antd";
import { Link, useNavigate } from "react-router-dom";
import TopHeader from "../../common/TopHeader/TopHeader";
import Sidebar from "../../common/Sidebar/Sidebar";
// import FooterDashboard from "../../common/FooterDashboard/FooterDashboard";
import DepartmentsApi from "../../common/Apis/DepartmentsApi";
import CleaningTraceabilityItemApi from "../../common/Apis/CleaningTraceabilityItemApi";
import DepartmentDropdown from "../../common/DropDowns/Department";
const { Option } = Select;

const AddCleaningTraceabilityItem = () => {
  const navigate = useNavigate();
  const { Content } = Layout;
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const [loadings, setLoadings] = useState(false);

  const [Departments, setDepartments] = React.useState([]);
  const getDepartments = useCallback(() => {
    DepartmentsApi.ListDepartments()
      .then((response) => {
        console.log(response);
        setDepartments(response?.payloadDto);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  useEffect(() => {
    getDepartments();
  }, [getDepartments]);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      traceabilityName: data.traceabilityName,
      institutionDTO: {
        id: data.institutionId,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    CleaningTraceabilityItemApi.CreateTraceabilityItemApi(formData)
      .then((response) => {
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Created</span>,
          description: "Created Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        return navigate("/cleaning-traceability/cleaning-list");

      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>{err.apiError.status}</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };



  const [form] = Form.useForm();
  const [selectedOptions, setSelectedOptions] = useState([]);

  useEffect(() => {
    // if (selectedOptions.includes('all')) {
    //   const allDepartmentValues = Departments.map((department) => department.id);
    //   form.setFieldsValue({ institutionId: allDepartmentValues });
    // }
  }, [selectedOptions, form, Departments]);

  const handleSelectChange = (value) => {
    setSelectedOptions(value);

    // If 'Select All' is selected, deselect individual department options
    if (value.includes('all')) {
      const allDepartmentValues = Departments.map((department) => department.id);
      const filteredValues = value.filter((val) => val !== 'all');
      console.log(allDepartmentValues)
      console.log(filteredValues)
      form.setFieldsValue({ institutionId: [...filteredValues, ...allDepartmentValues] });
    }
  };

  const options = Departments.map((option) => ({
    value: option.id,
    label: option.institutionName,
  }));

  options.unshift({ value: 'selectAll', label: 'Select All' });


  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar />
      <Layout>
        <TopHeader />

        <Content
          className="form-content nav-content"
          style={{
            margin: "16px 16px 0",
            padding: "30px",
            background: colorBgContainer,
          }}
        >
          <Form
            name="nest-messages"
            layout="vertical"
            className="FormClass"
            form={form}
            onFinish={handleSubmit}
          >
            <>
              <Row gutter={16}>
                <Col lg={8} md={12}>
                  <Form.Item
                    name="traceabilityName"
                    label="Cleaning Item"
                    className="text-lable"
                    rules={[
                      {
                        required: true,
                        message: "Please enter Cleaning Item",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      placeholder="Cleaning Item"
                      className="control-input"
                    />
                  </Form.Item>
                </Col>
                <Col lg={9} md={12}>

                  <DepartmentDropdown />
                </Col>
              </Row>

              <div className="d-flex justify-content-end pt-5">
                <Link
                  type="primary"
                  to={""}
                  onClick={handleGoBack}
                  className="btn btn-primary btn-back"
                >
                  Back
                </Link>

                <Button
                  type="primary"
                  htmlType="submit"
                  className="btn btn-primary btn-save"
                >
                  Create {loadings == true && <Spin className="px-2" />}
                </Button>
              </div>
            </>
          </Form>
        </Content>
        {/* <FooterDashboard /> */}
      </Layout>
    </Layout>
  );
};
export default AddCleaningTraceabilityItem;
